// Financial Services Section Data
export const FINANCIAL_SERVICES_DEFAULT_PRODUCTS = [
  {
    link: 'https://cleartax.in/income-tax-efiling?utm_ref=itr_2025_organic_CT_homepage',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/24752bcd-1c44-4e33-a907-d28c0c63f9d8.png',
    title: 'Self ITR Filing',
    description: 'ITR filing for every tax situation',
    mobile_description: 'ITR filing for every tax situation',
  },
  {
    link: 'https://cleartax.in/s/pricing?utm_ref=itr_2025_organic_CT_homepage',
    icon: 'https://assets.clear.in/cleartax/images/1689834900_group1814218524.png',
    title: 'Expert Filing',
    description: "ITR filed by India's top Tax Experts",
    mobile_description: "ITR filed by India's top Tax Experts",
  },
  {
    link: 'https://taxcloudindia.com/Entity#/',
    icon: 'https://assets.clear.in/cleartax/images/1689834930_group1814218517.png',
    title: 'Taxcloud',
    description: 'ITR filing software for Tax Experts',
    mobile_description: 'ITR filing software for Tax Experts',
  },
  {
    link: 'https://cleartax.in/gst',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/1c380469-b051-4882-a1dc-d71fe81fed7a.png',
    title: 'GST software',
    description: 'G1-G9 filings made 3x faster',
    mobile_description: 'G1-G9 filings made 3x faster',
  },
];
